import {
  SalaryHistoryTravelItem,
  SalaryItemRate,
} from '../../../../api/types/accountants/salary-history/salary-history.type';
import { LecturerRateDisplayType } from '../../../../api/types/lecturers/price-rate/lecturer-rate-display-type';

const getBillingFactor = (displayType: LecturerRateDisplayType): number =>
  displayType === LecturerRateDisplayType.OneHour ? 1 : 4 / 3;

const getUnitMinutes = (displayType: LecturerRateDisplayType): number =>
  displayType === LecturerRateDisplayType.OneHour ? 60 : 45;

export const getItemBilledQuantity = (item: SalaryItemRate): number => {
  return item.hoursNumber * getBillingFactor(item.displayType);
};

export const getItemBreakHourUnits = (item: SalaryItemRate): number => {
  const breakMinutes = item.breakMinutes ?? 0;
  if (breakMinutes <= 0) {
    return 0;
  }

  return breakMinutes / getUnitMinutes(item.displayType);
};

export const getItemAdjustedBilledQuantity = (item: SalaryItemRate): number => {
  return Math.max(0, getItemBilledQuantity(item) - getItemBreakHourUnits(item));
};

export const getItemAdjustedLineAmount = (item: SalaryItemRate): number => {
  const rate = Number(item.rate);
  if (!Number.isFinite(rate)) {
    return 0;
  }

  return getItemAdjustedBilledQuantity(item) * rate;
};

export const getSalaryBreakHourUnitsTotal = (
  items: SalaryItemRate[],
): number => {
  return items.reduce((sum, item) => sum + getItemBreakHourUnits(item), 0);
};

export const getSalaryTotalWithBreakDeduction = (
  items: SalaryItemRate[],
  travelItems: SalaryHistoryTravelItem[] = [],
): number => {
  const itemsTotal = items.reduce(
    (sum, item) => sum + getItemAdjustedLineAmount(item),
    0,
  );
  const travelTotal = travelItems.reduce(
    (sum, t) => sum + (Number(t.amount) || 0),
    0,
  );

  return itemsTotal + travelTotal;
};

export const formatHourUnits = (value: number): string => {
  const formatted = value % 1 === 0 ? value.toString() : value.toFixed(2);
  return `${formatted} שעות`;
};
